import React, { useEffect } from 'react';
import CustomButton from 'components/common/custom-button';
import Input from 'components/input';
import Select from 'components/select';
import { FlexRow } from './Authentication.style';

const PrimaryForm = ({ areaCodeArr, formikProps, isLoading, get2fadata, mobile }) => {
  const { values, handleChange, handleBlur, errors, touched, setFieldValue } = formikProps;
  useEffect(() => {
    const { primary_2fa_area_code, primary_2fa_phone } = get2fadata;
    setFieldValue('primary_2fa_area_code', primary_2fa_area_code);
    setFieldValue('primary_2fa_phone', primary_2fa_phone);
  }, [get2fadata]);
  return (
    <FlexRow>
      <div style={{ width: mobile ? '100%' : '360px', display: 'flex', zIndex: 10000, marginRight: '10px' }}>
        <Select
          options={areaCodeArr || []}
          name={'primary_2fa_area_code'}
          value={values['primary_2fa_area_code']}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['primary_2fa_area_code']}
          touched={touched['primary_2fa_area_code']}
        />
        <Input
          styling={{ height: '49px', marginTop: '-6px', marginLeft: '10px', width: '100%' }}
          name={'primary_2fa_phone'}
          value={values['primary_2fa_phone']}
          onChange={(event) => {
            const numericValue = event.target.value.replace(/[^0-9]/g, '');
            setFieldValue('primary_2fa_phone', numericValue);
          }}
          onBlur={handleBlur}
          error={errors['primary_2fa_phone']}
          touched={touched['primary_2fa_phone']}
          placeholderClass
        />
      </div>
      <CustomButton
        type="submit"
        buttonStyles={{ marginTop: mobile ? '10px' : '20px', height: '48px', padding: '0 21px' }}
        isLoading={isLoading}
      />
    </FlexRow>
  );
};

export default PrimaryForm;
